import type { JSX } from 'react';
import type { QuestionOption } from '@logistics/contracts';
import { sourceGlyph } from '@/lib/glyphs';
import type { ScopeOption } from './use-chat-data';

/** The SEARCH IN chips: one per source; one with nothing connected here is disabled. */
export function ScopeChips({
  scopes,
  scope,
  onToggle,
}: {
  scopes: readonly ScopeOption[];
  scope: readonly QuestionOption[];
  onToggle: (option: QuestionOption) => void;
}): JSX.Element {
  return (
    <div className="flex flex-wrap gap-[5px]">
      {scopes.map((s) => {
        const on = s.available && scope.includes(s.option);
        return (
          <button
            key={s.option}
            type="button"
            disabled={!s.available}
            onClick={() => onToggle(s.option)}
            aria-pressed={on}
            title={s.available ? s.label : `${s.label} — not connected`}
            className="rounded-md border px-2 py-[3px] font-mono text-[10.5px] transition-all duration-200 disabled:cursor-not-allowed disabled:opacity-40"
            style={{
              borderColor: on ? 'color-mix(in oklch, var(--acc) 40%, transparent)' : 'var(--line)',
              background: on ? 'var(--accSoft)' : 'transparent',
              color: on ? 'var(--acc)' : 'var(--mute)',
            }}
          >
            {sourceGlyph(s.option)}
          </button>
        );
      })}
    </div>
  );
}
